// Chakra imports
import { Flex, Text } from '@chakra-ui/react';

// Custom components
import { HSeparator } from 'components/separator/Separator';

export function SidebarBrand() {
	return (
		<Flex alignItems='center' flexDirection='column'>
			<Text mb={5} fontWeight={600} fontSize='24px'>AUTOMAFOUR</Text>
			<HSeparator mb='20px' />
		</Flex>
	);
}

export default SidebarBrand;
